import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { AuthStore } from '@store';

export const authGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  return combineLatest([
    authStore.state$,
    authStore.isEndUserWithoutAccess$,
    authStore.isAuthenticating$.pipe(filter((isAuthenticating) => !isAuthenticating)),
    authStore.isAuthorizing$.pipe(filter((isAuthorizing) => !isAuthorizing)),
  ]).pipe(
    map(([state, isEndUserWithoutAccess]) => {
      if ((!state.authorized && !state.authorizing) || isEndUserWithoutAccess) {
        router.navigate(['/home']);
      } else {
        return true;
      }
    })
  );
};
